import { CLICK_IDS } from '@sunflower-games/analytics-events';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';
import { DialogContent } from '../../../components/Dialog/DialogContent';
import { DialogHeader } from '../../../components/Dialog/DialogHeader';
import { analytics } from '../../../services/analytics';
import { useStores } from '../../../stores/useStores';

import styles from './PocReactionSuccessView.module.scss';

export const PocReactionSuccessView = observer(function PocReactionSuccessView() {
  const { t } = useTranslation();
  const { portalStore } = useStores();

  const handleClose = () => {
    void analytics.sendEvent('automatic_poc', {
      step: 'automatic_poc_finished',
      event_action: 'click',
      click_id: CLICK_IDS.POC.AWESOME,
      triggered_by: 'click',
    });

    portalStore.closePortal();
  };

  return (
    <>
      <DialogHeader title={t('poc.allDone')} onClose={handleClose} />
      <DialogContent className={styles.content}>
        <p className={styles.prompt}>{t('poc.creditCardVerificationSubmitted')}</p>
        <Button btnType="main" className={styles.okButton} onClick={handleClose}>
          {t('buttons.awesome')}
        </Button>
      </DialogContent>
    </>
  );
});
